module.exports = __webpack_public_path__ + "img/undraw_searching.ef985a6b.svg";